import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import mainRoutes from './routes/main';
import legalRoutes from './routes/legal';
import technologyRoutes from './routes/technology';
import usesRoutes from './routes/uses';
import resourcesRoutes from './routes/resources';
import companyRoutes from './routes/company';

// Create an array with 404 route
const notFoundRoute: RouteRecordRaw[] = [
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "not-found" */ '@/views/NotFoundView.vue'),
    meta: {
      title: 'Page Not Found',
    },
  },
];

// Combine all routes
const routes: RouteRecordRaw[] = [
  ...mainRoutes,
  ...legalRoutes,
  ...technologyRoutes,
  ...usesRoutes,
  ...resourcesRoutes,
  ...companyRoutes,
  ...notFoundRoute,
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  // Scroll behavior
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

// Navigation guards for page titles and auth
router.beforeEach((to, from, next) => {
  // Set document title based on route meta
  document.title = `${to.meta?.title || 'Page'} | thenti`;

  // Check auth if needed
  if (to.meta?.requiresAuth) {
    // Implement your auth check logic here
    // For now, we'll just proceed
  }

  next();
});

export default router;
